import React, { useState } from 'react';
import style from './mobileShareLink.module.scss';
import ShareLinkIcon from 'icons/shareLink';
import Popper from '@mui/material/Popper';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ClickAwayListener from '@mui/material/ClickAwayListener';

export const MobileShareLink = ({ link }: { link: string }) => {
  const [popperText, setPopperText] = useState('');
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const handleClickIcon = async (event: React.MouseEvent<HTMLDivElement>) => {
    if (anchorEl) {
      setAnchorEl(null);
      return;
    }

    const targetEl = event.currentTarget;
    try {
      await navigator.clipboard.writeText(link);
      setPopperText('Ссылка на изображение была успешно скопирована');
      setAnchorEl(targetEl);
    } catch (e) {
      setPopperText('Ошибка: не удалось скопировать ссылку на изображение');
      setAnchorEl(targetEl);
    }
  };

  const handleClosePopper = () => setAnchorEl(null);

  const open = Boolean(anchorEl);
  const id = open ? 'copy-to-clipboard-popper' : undefined;

  return (
    <ClickAwayListener onClickAway={handleClosePopper}>
      <div>
        <div
          className={style.shareLinkIconWrapper}
          onClick={async (e: React.MouseEvent<HTMLDivElement, MouseEvent>) =>
            handleClickIcon(e)
          }
        >
          <ShareLinkIcon
            className={style.shareLinkIcon}
            fill={'white'}
          ></ShareLinkIcon>
        </div>

        <Popper
          id={id}
          open={open}
          anchorEl={anchorEl}
          placement="top-end"
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper>
                <Typography sx={{ p: 2 }}>{popperText}</Typography>
              </Paper>
            </Fade>
          )}
        </Popper>
      </div>
    </ClickAwayListener>
  );
};
